import React from "react";
import { User } from "lucide-react";
import { cn } from "@/lib/utils";
import { RegionUserProfile } from "@/services/authService";

interface ConciergeCellProps {
    conciergeData?: RegionUserProfile | null;
    className?: string;
}

export const ConciergeCell: React.FC<ConciergeCellProps> = ({
    conciergeData,
    className = "",
}) => {
    if (!conciergeData) {
        return <div className={cn("text-center", className)}>-</div>;
    }

    const conciergeName =
        `${conciergeData.firstName || ""} ${conciergeData.lastName || ""}`.trim() ||
        conciergeData.email;

    const iconSize = 26;

    return (
        <div className={cn("flex flex-col items-center gap-2", className)}>
            <div className="flex items-center justify-center">
                <User size={iconSize} className="text-muted-foreground" />
            </div>
            <div className="flex flex-col">
                <span className="text-sm font-medium">{conciergeName}</span>
            </div>
        </div>
    );
};
